export const V1 = '2014-02-11';

const V5 = '2018-02-08';
export const LATEST_VERSION = V5;
export const VERSION_HEADER = 'Shippo-API-Version';
export const OVERRIDE_ADDRESS_HEADER = 'Shippo-Override-Addresses';
export const OVERRIDE_ADDRESS_VERSION = 'V2';
export const SHIPPO_STATUS_PAGE = 'https://status.goshippo.com/';
